import React, { useEffect, useRef } from 'react'
import { Button } from 'react-bootstrap'
import SamplePdf from '../../pdf/society_redevelopment.pdf'
import Floatingbutton from './Floatingbutton'
import PageHeader from '../Elements/UI/PageHeader'
import EmptyState from '../Elements/UI/EmptyState'
import FeedSkeleton from '../Elements/UI/FeedSkeleton'
import FeedTime from '../Elements/UI/FeedTime'
import DeleteButton from '../Elements/UI/DeleteButton'
import Opendocumentmodal from '../Modals/Opendocumentmodal'
import Conformationdocumentmodal from '../Modals/Conformationdocumentmodal'
import { connect } from 'react-redux'
import axios from 'axios'
import config from '../../config'
import { toast } from 'react-toastify'
import DocumentCard from './SmallComponents/DocumentCard'
import { Type } from 'lucide-react'

function DocumentsPage({ userAccess = [] }) {
  const wideBlockRef = useRef()
  const [showModal, setShowModal] = React.useState(false)
  const [selectId, setSelectId] = React.useState(null)
  const [showConfirmModal, setShowConfirmModal] = React.useState(false)
  const [deleteId, setDeleteId] = React.useState(null)
  const [inputData, setInputData] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [documentdata, setDocumentdata] = React.useState([])

  useEffect(() => {
    fetchmydocs().finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    if (showModal) {
      fetchinputs()
    }
  }, [showModal])
  const handlemodalOpen = id => {
    setSelectId(id)
    setShowModal(true)
  }

  const handleDeleteDocument = pollID => {
    setDeleteId(pollID)
    setShowConfirmModal(true)
  }

  // const handleConfirmDelete = () => {
  //   setDocumentdata(documentdata.filter(item => item.id !== deleteId))
  //   setShowConfirmModal(false)
  //   setDeleteId(null)
  //   console.log('Delete document:', deleteId)
  // }

  const handleCancelDelete = () => {
    setShowConfirmModal(false)
    setDeleteId(null)
  }

  const handleConfirmDelete = async () => {
    if (!deleteId) return
    const token = localStorage.getItem('token')
    try {
      await axios.delete(`${config.apiUrl}/post/${deleteId}`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        }
      })

      setDocumentdata(prev => prev.filter(item => item.pollId !== deleteId))
      toast.success('Post deleted successfully!')
      setShowConfirmModal(false)
      setDeleteId(null)
    } catch (e) {
      console.error(e)
      toast.error('Failed to delete post')
    }
  }

  const fetchmydocs = async () => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.get(config.apiUrl + '/post/Document', {
        headers: { Authorization: token }
      })

      console.log('FULL API RESPONSE:', res.data)

      const normalized = (res.data.data || [])
        // .filter(post => post.Type === 'Document')
        .map(post => ({
          pollId: post.ID,
          type: post.Type,
          title: post?.Data?.Title || '',
          document: post?.Data?.DocumentLink?.data || '',
          documentdata: post?.Data?.DocumentLink?.fileData,
          CreatedOn: post.CreatedOn,
          ...post
        }))
        .sort((a, b) => b.pollId - a.pollId)
      console.log({ normalized }, res.data.data)
      setDocumentdata(normalized)
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch polls')
    }
  }

  const DocUploaddocuments = async formData => {
    const token = localStorage.getItem('token')
    try {
      const res = await axios.post(`${config.apiUrl}/upload/image`, formData, {
        headers: {
          Authorization: token
        }
      })
      if (res.status === 200) {
        console.log(res.data)
        const uploadObj = res.data
        delete uploadObj.message
        delete uploadObj.status
        setShowModal(false)
        return res.data
      }
    } catch (e) {
      console.log('File upload faled', e)
      toast.error('File Upload Failed')
    }
  }

  const fetchinputs = async () => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.get(
        `${config.apiUrl}/projects/projects-with-wings`,
        {
          headers: { Authorization: token }
        }
      )
      console.log('FULL API RESPONSE:', res.data)
      const normalized = (res.data || []).flatMap(project =>
        (project.Wings || []).map(wing => ({
          projectId: project.ID,
          projectName: project.Name.trim(),
          wingId: wing.ID,
          wingName: wing.Name
        }))
      )
      setInputData(normalized)
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch posts')
    }
  }

  const Docupload = async data => {
    const token = localStorage.getItem('token')
    try {
      const postdata = await axios.post(
        `${config.apiUrl}/post/Document`,
        data,
        {
          headers: {
            Authorization: token
          }
        }
      )

      if (postdata.status === 200) {
        const apiPost = postdata.data?.data
        let imageUrl = ''
        if (apiPost?.Data?.ImageLink) {
          if (
            typeof apiPost.Data.ImageLink === 'object' &&
            apiPost.Data.ImageLink.data
          ) {
            imageUrl = apiPost.Data.ImageLink.data
          } else if (typeof apiPost.Data.ImageLink === 'string') {
            imageUrl = apiPost.Data.ImageLink
          }
        } else if (data?.Data?.DocumentLink?.data) {
          imageUrl = data.Data.DocumentLink.data
        }

        const newPost = {
          pollId: apiPost?.ID || Date.now(),
          type: apiPost?.Type || 'Updates',
          title: apiPost?.Data?.Title || data.Data.Title || 'Untitled',
          image: imageUrl,
          CreatedOn: apiPost?.CreatedOn || new Date().toISOString(),
          Data:{
            Title: apiPost?.Data?.Title || data.Data.Title,
            DocumentLink: data.Data.DocumentLink,
            data: apiPost?.Data?.data || ''
          },
          ID: apiPost?.ID,
          Type: apiPost?.Type,
          ...apiPost
        }
        console.log('my-image', newPost.image)

        setDocumentdata(prev => [newPost, ...prev])
        setShowModal(false)
      }
    } catch (e) {
      console.error('Post upload failed', e)
      toast.error('Post Not Uploaded')
    }
  }

  useEffect(() => {
    const updateHeight = () => {
      const fullHeight = window.innerHeight
      const offset = 100 // adjust this based on your header or spacing
      if (wideBlockRef.current) {
        wideBlockRef.current.style.maxHeight = `${fullHeight - offset}px`
      }
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)

    return () => window.removeEventListener('resize', updateHeight)
  }, [])
  const canDelete = Array.isArray(userAccess) && userAccess.includes('DeleteDocument')

  return (
    <div id="appCapsule">
      <div className="section full mt-1">

        <div className="wide-block mt-1" ref={wideBlockRef}>
          <PageHeader title="Project management" subtitle="Agreements, approvals and official documents" />

          {loading && <FeedSkeleton label="Loading documents" />}

          {!loading && (!Array.isArray(documentdata) || documentdata.length === 0) && (
            <EmptyState icon="document-attach-outline" title="No documents yet" text="New items will appear here once they are posted." />
          )}

          <div className="timeline timed">
            {documentdata.map(item => (
              <div className="item" key={item.pollId}>
                <FeedTime value={item.CreatedOn} />

                <div className="dot bg-secondary" aria-hidden="true"></div>
                <div className="content">
                  <article className={`card bl-feed-card${canDelete ? ' has-action' : ''}`}>
                    {canDelete && (
                      <DeleteButton onClick={() => handleDeleteDocument(item.pollId)} label="Delete document" />
                    )}
                    <DocumentCard item={item} />
                    {/* <div className="d-flex flex-column align-items-center">
                      <div className="content">
                        <div className="d-flex flex-column align-items-center">
                          <ion-icon
                            name="document-attach-outline"
                            style={{ fontSize: '62px', color: 'gray' }}
                          ></ion-icon>
                        </div>
                        <p className="text-center">{item.title}</p>
                        <div className="d-flex flex-column align-items-center">

                          <div className="mt-3 d-flex gap-2">
                            
                            <a
                              href={item.document}
                              target="_blank"
                              className="btn btn-outline-secondary btn-lg p-2"
                            >
                              View
                            </a>

                            <a
                              href={item.document}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-outline-secondary btn-lg p-2"
                            >
                              Download
                            </a>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </article>
                </div>
              </div>
            ))}
          </div>
        </div>
        {userAccess.includes('CreateDocument') && (
          <Floatingbutton onOpen={handlemodalOpen} />
        )}
        <Opendocumentmodal
          show={showModal}
          userId={selectId}
          onDocument={DocUploaddocuments}
          onUpdate={Docupload}
          inputData={inputData}
          fetchinputs={fetchinputs}
          onClose={() => setShowModal(false)}
        />
        <Conformationdocumentmodal
          show={showConfirmModal}
          onClose={handleCancelDelete}
          onDelete={handleConfirmDelete}
        />
      </div>
    </div>
  )
}

const mapStateToProps = ({ auth }) => {
  const { userAccess } = auth
  return {
    userAccess
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsPage)
